import { render } from "./lorry_wise_sale.vue?vue&type=template&id=068c7602&scoped=true"
import script from "./lorry_wise_sale.vue?vue&type=script&lang=js"
export * from "./lorry_wise_sale.vue?vue&type=script&lang=js"

import "./lorry_wise_sale.vue?vue&type=style&index=0&id=068c7602&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068c7602"]])

export default __exports__